import React from "react";
import Pagination from "@mui/material/Pagination";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import moment from "moment";
import { useSelector } from "react-redux";
import { Tooltip } from "@mui/material";

import { BoxTotalsFlows } from "../pptos/list/BoxTotalsFlows";

export const TableListAprobadosModoFlujo = ({ filters, setFilters }) => {

  const { access } = useSelector((state) => state.auth);
  const { list } = useSelector((state) => state.ppto);
  const { cantidad } = useSelector((state) => state.ppto.totales);

  const handleChange = (event, value) => {
    const newFilters = {
      ...filters,
      page: value,
    };
    setFilters(newFilters);
  };

  return (
    <>
      <BoxTotalsFlows />

      <div className="p-table">
        <div className="flex justify-between items-center">
          {cantidad > 0 ? (
            <div className="ms-2 text-gray-500">
              {cantidad || 0} proyectos encontrados
            </div>
          ) : (
            <div></div>
          )}

          <Pagination
            count={Math.max(1, Math.ceil(Number(cantidad || 0) / filters.rows))}
            page={Number(filters.page) || 1}
            size="small"
            onChange={handleChange}
          />
        </div>

        <div className="overflow-x-auto">
          <table className="table p-table-global">
            <thead className="p-thead-global">
              <tr className="text-center">
                <th colSpan={5} className="text-end"></th>
                <th
                  className="text-center"
                  style={{
                    borderLeft: "1px solid lightgray",
                    color: "#595759",
                  }}
                >
                  PRESUPUESTO APROBADO
                </th>
                {access.a20 && (
                  <th
                    className="content-center"
                    colSpan={4}
                    style={{
                      borderLeft: "1px solid lightgray",
                      color: "#595759",
                    }}
                  >
                    <span>FLUJO DE EFECTIVO (neto)</span>
                  </th>
                )}
              </tr>
              <tr className="text-center text-gray-500">
                <th>Número</th>
                <th>Fecha</th>
                <th>Ejecutivo</th>
                <th className="text-start sticky left-0 z-10 bg-white">
                  Referencia
                </th>
                <th className="text-start min-w-60">Cliente</th>
                <th className="min-w-24 text-end border-s border-s-gray-300">
                  <span className="me-2">Total Neto</span>
                </th>
                <th className="border-s border-s-gray-300 text-end">Cobrado</th>
                <th className="text-end">Pagado</th>
                <th className="text-end">
                  <span className="me-2">Saldo ( en caja )</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {list.map((p) => (
                <tr className="p-tr-body-global" key={p.id}>
                  <td className="text-center align-start">
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      #{p.numero}
                    </Link>
                  </td>
                  <td
                    className="text-center align-start"
                    title={moment(p.fecha_asignacion).format("DD-MM-YYYY")}
                  >
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      {moment(p.fecha_asignacion).format("MMM YYYY")}
                    </Link>
                  </td>
                  <td>
                    <Link className="LinkTable" to={`/projects/${p.id}`}>
                      <div className="row photo scale-90">
                        <div className="col d-flex justify-content-center">
                          <div className="d-flex justify-content-center align-items-center p-container-foto">
                            <Tooltip
                              title={`${p.ejecutivo_nombre}${" "}${p.ejecutivo_apellidos}`}
                            >
                              <span>
                                {p.ejecutivo_nombre
                                  ? p.ejecutivo_nombre.substring(0, 1)
                                  : ""}
                                {p.ejecutivo_apellidos
                                  ? p.ejecutivo_apellidos.substring(0, 1)
                                  : ""}
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </Link>
                  </td>
                  <td className="text-clientes text-start align-start sticky left-0 z-10 bg-white">
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      {p.referencia || "---"}
                    </Link>
                    {p.estado_cierre !== "abierto" &&
                    p.estado_cierre !== "" &&
                    p.estado_cierre !== null ? (
                      <div style={{ marginBottom: "-18px" }}>
                        <span className={`p-label-${p.estado_cierre}-list`}>
                          {p.estado_cierre === "cerrado" && (
                            <i className="bi bi bi-lock"></i>
                          )}
                          {p.estado_cierre === "pausado" && (
                            <i className="bi bi-pause-circle"></i>
                          )}
                          <label className="ms-1">{p.estado_cierre}</label>
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                  </td>
                  <td className="text-clientes text-start align-start">
                    <Link
                      className="LinkTable text-[11px]"
                      to={`/projects/${p.id}`}
                    >
                      {p.cliente || "---"}
                    </Link>
                  </td>

                  {/* venta */}
                  <td className="text-center align-bottom border-s border-s-gray-300 min-w-24">
                    <Link className="LinkTable" to={`/projects/${p.id}`}>
                      <div className="text-[12px] font-bold text-[#3e80ff]">
                        <NumberFormat
                          value={p.total_neto ? parseFloat(p.total_neto) : 0}
                          displayType={"text"}
                          thousandSeparator={p.separacion_miles}
                          decimalSeparator={p.separacion_decimales}
                          decimalScale={2}
                          prefix={`${p.simbolo} `}
                          fixedDecimalScale
                        />
                      </div>
                    </Link>
                  </td>

                  {/* ingresos */}
                  <td className="text-end align-bottom border-s border-s-gray-300 min-w-24">
                    <Link className="LinkTable" to={`/projects/${p.id}`}>
                      <div className="text-[11px] text-green-500">
                        <NumberFormat
                          value={
                            p.total_cobrado
                              ? (parseFloat(p.total_cobrado) /
                                  parseFloat(p.total_neto)) *
                                100
                              : 0
                          }
                          displayType={"text"}
                          thousandSeparator={","}
                          decimalSeparator="."
                          decimalScale={2}
                          suffix=" %"
                          fixedDecimalScale
                        />
                      </div>
                      <div className="text-[12px] font-bold text-green-500 min-w-24">
                        <NumberFormat
                          value={
                            p.total_cobrado ? parseFloat(p.total_cobrado) : 0
                          }
                          displayType={"text"}
                          thousandSeparator={p.separacion_miles}
                          decimalSeparator={p.separacion_decimales}
                          decimalScale={2}
                          prefix={`${p.simbolo} `}
                          fixedDecimalScale
                        />
                      </div>
                    </Link>
                  </td>

                  {/* egresos */}
                  <td className="text-end align-bottom min-w-24">
                    <Link className="LinkTable" to={`/projects/${p.id}`}>
                      <div className="text-[11px] text-red-600">
                        <NumberFormat
                          className=""
                          value={
                            p.total_pagado
                              ? (parseFloat(p.total_pagado) /
                                  parseFloat(p.total_neto)) *
                                100
                              : 0
                          }
                          displayType={"text"}
                          thousandSeparator={","}
                          decimalSeparator="."
                          decimalScale={2}
                          suffix=" %"
                          fixedDecimalScale
                        />
                      </div>
                      <div className="text-[12px] font-bold text-red-600 min-w-24">
                        <NumberFormat
                          value={
                            p.total_pagado ? parseFloat(p.total_pagado) : 0
                          }
                          displayType={"text"}
                          thousandSeparator={p.separacion_miles}
                          decimalSeparator={p.separacion_decimales}
                          decimalScale={2}
                          prefix={`${p.simbolo} `}
                          fixedDecimalScale
                        />
                      </div>
                    </Link>
                  </td>

                  {/* utilidad */}
                  <td className="text-end align-bottom min-w-24">
                    <Link className="LinkTables" to={`/projects/${p.id}`}>
                      <div className="text-[11px] text-green-600">
                        <NumberFormat
                          value={
                            p.saldo
                              ? (parseFloat(p.saldo) /
                                  parseFloat(p.total_neto)) *
                                100
                              : 0
                          }
                          displayType={"text"}
                          thousandSeparator={","}
                          decimalSeparator="."
                          decimalScale={2}
                          suffix=" %"
                          fixedDecimalScale
                        />
                      </div>
                      <div className="text-[12px] font-bold text-green-600 min-w-24">
                        <NumberFormat
                          value={p.saldo ? parseFloat(p.saldo) : 0}
                          displayType={"text"}
                          thousandSeparator={p.separacion_miles}
                          decimalSeparator={p.separacion_decimales}
                          decimalScale={2}
                          prefix={`${p.simbolo} `}
                          fixedDecimalScale
                        />
                      </div>
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
